import { useCallback } from 'react';
import { useOtherSettings } from '@namespace/cms';

interface NativePostMessage {
  [key: string]: unknown;
}

export const useNativePostMessage = (): ((
  message: NativePostMessage
) => void) => {
  const { nativeAppPostMessageHost = '*' } = useOtherSettings();

  return useCallback(
    (message: NativePostMessage) => {
      console.log(message, 'NATIVE_SEND try');
      if (window.nativeApp?.postMessage) {
        console.log(message, 'NATIVE_SEND postMessage');
        if (nativeAppPostMessageHost) {
          window.nativeApp.postMessage(JSON.stringify(message), '*');
        } else {
          window.nativeApp.postMessage(JSON.stringify(message));
        }
      } else {
        console.error('postMessage to native app not sent');
      }
    },
    [nativeAppPostMessageHost]
  );
};
